<script setup>
import BaseDynamicForm from '@/components/base/BaseDynamicForm.vue'

import { computed, ref, defineExpose } from 'vue'
import { useStore } from '@/utils/VuexHelpers'

const store = useStore()

const dialog = ref(false)
const selectedDocket = ref(null)

const loadingRevenue = computed(() => store.getters.loadingRevenue)

const fields = computed(() => [
  {
    key: 'destination',
    label: 'Customer',
    value: selectedDocket.value?.destination_co_id || null,
    type: 'destination-select',
    rules: [(v) => !!v || 'Customer is required'],
    placeholder: 'Select customer...'
  }
])

const isLoading = computed(() => {
  return loadingRevenue.value === `update-${selectedDocket.value?.id}`
})

const edit = (item) => {
  selectedDocket.value = item
  dialog.value = true
}

const buildPayload = (formData) => {
  return {
    id: selectedDocket.value.id,
    destination_co_id: formData.destination
  }
}

const handleFormSubmit = async (formData) => {
  const payload = buildPayload(formData)

  const res = await store.dispatch('updateRevenue', {
    payload
  })

  if (res === 'error') return

  dialog.value = false
  selectedDocket.value = null

  store.dispatch('fetchRevenue')
}

defineExpose({
  edit
})
</script>

<template>
  <v-dialog v-model="dialog" scrollable max-width="500px">
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        <div class="d-flex align-start flex-column">
          <h6
            class="text-button text-light-blue text-start mb-0"
            style="line-height: 1.5rem"
          >
            Update Customer
          </h6>

          <div
            v-if="selectedDocket?.docket"
            class="text-body-2 grey--text text--darken-1"
          >
            Docket:
            <span class="font-italic">{{ selectedDocket.docket }}</span>
          </div>

          <div
            v-if="selectedDocket?.destination?.name"
            class="text-body-2 grey--text text--darken-1"
          >
            Current Customer:
            <span class="font-italic">
              {{ selectedDocket.destination.name }}
            </span>
          </div>
        </div>
      </v-card-title>

      <v-divider class="mt-0 mb-1" />

      <v-card-text>
        <BaseDynamicForm
          :formFields="fields"
          :loading="isLoading"
          :resetOnInputChange="true"
          @submit="handleFormSubmit"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
